import React, { useEffect, useState } from 'react';
import answerIcon from '@/public/icons/answer.svg';
import { useStore } from '@/stores';
import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';
import { Avatar, Button, Col, notification, Row } from 'antd';
import { CloseBtn } from '@/public/closeBtn';
import { SipJs } from '@/services/sip-js.service';
import { MessageIcon } from '@/components/MessageIcon/MessageIcon';
import { Dynamics } from '@/services/dynamics/dynamics';
import { commonMakeCall } from '@/shared/helpers/common-make-call.helper';
import { MissedCallIcon } from '@/public/icons/colorful/MissedCall';
import { ENTITY_DIRECTION_TYPE } from '@/shared/constants/entityDirectionType';
import './CallDetails.scss';

export const CallDetails = observer(() => {
  const {
    callStore: { contacts, setContacts },
  } = useStore();
  const [contactName, setContactName] = useState('');
  const [notificationApi, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const location = useLocation();
  const { entity } = location.state;

  const onPageClose = () => {
    navigate('/activity-history');
  };

  const onCallBack = async () => {
    const { state } = await navigator.permissions.query({
      name: 'microphone' as PermissionName,
    });
    if (state !== 'granted') {
      notificationApi.error({
        message: 'Microphone permission is required',
        placement: 'bottomRight',
        duration: 5,
        className: 'notifications',
      });

      return;
    }
    if (SipJs.sessions?.length) {
      return;
    }

    commonMakeCall(contacts, entity.phoneNumber);
  };

  useEffect(() => {
    async function getContactByPhoneNumber() {
      const entities = await Dynamics.searchEntities(entity.phoneNumber, true);
      setContacts(entities);
      setContactName(entities?.[0]?.fullName || 'Unknown contact');
    }

    async function getContactBySpecificSessionData() {
      //const specificData = SipJs.sessions.
      const entities = await Dynamics.searchEntities(entity.phoneNumber, true);
      setContacts(entities);
      setContactName(entities?.[0]?.fullName || 'Unknown contact');
    }

    getContactByPhoneNumber();
    getContactBySpecificSessionData();
  }, []);

  return (
    <div className="call-details">
      {contextHolder}
      <Row className="call-container">
        <Col span={5} className="avatar-container">
          <Avatar className="avatar" alt="Avatar" icon={<MissedCallIcon />} />
        </Col>
        <Col span={15}>
          <div>{entity?.fullName}</div>
          <div className="phone-title">{entity?.phoneNumber}</div>
        </Col>
        <Col span={4}>
          <button
            data-testid="close-call-details"
            onClick={onPageClose}
            className="close"
          >
            <CloseBtn />
          </button>
        </Col>
      </Row>
      <div className="call-details-item">
        <span className="item-title">
          {entity?.direction === ENTITY_DIRECTION_TYPE.OUTBOUND ? 'To' : 'From'}
        </span>
        <span>{contactName}</span>
      </div>
      <div className="call-details-item">
        <span className="item-title">Phone Number</span>
        <span>{entity?.phoneNumber}</span>
      </div>
      <div className="call-details-item">
        <span className="item-title">Date</span>
        <span>{`${entity.date.toLocaleString().replace(/\(.+\)/g, '')}`}</span>
      </div>
      <Button
        disabled={!entity?.phoneNumber}
        data-testid="call-back-button"
        className="call-details-button"
        type="primary"
        icon={<MessageIcon svgUrl={answerIcon} />}
        onClick={onCallBack}
      >
        Call Back
      </Button>
    </div>
  );
});
